"use strict";

document.addEventListener('DOMContentLoaded', function() {
    // Получаем все элементы с классом 'acc_title'
    var acc = document.querySelectorAll('.acc_title');

    // Функция для установки максимальной высоты панели
    function setPanelHeight(panel, height) {
        panel.style.maxHeight = height;
    }

    // Функция для обновления высоты панели при изменении содержимого
    function updatePanelHeight(panel) {
        if (panel.style.maxHeight) {
            setPanelHeight(panel, panel.scrollHeight + "px");
        }
    }

    // Функция для добавления обработчиков загрузки изображений
    function addImageLoadListeners(panel) {
        var images = panel.querySelectorAll('img');
        images.forEach(function(img) {
            img.addEventListener('load', function() {
                updatePanelHeight(panel);
            });
        });
    }

    // Инициализация активных панелей при загрузке страницы
    acc.forEach(function(item) {
        if (item.classList.contains('active')) {
            var panel = item.nextElementSibling;
            setPanelHeight(panel, panel.scrollHeight + "px");

            // Создаем MutationObserver для отслеживания изменений в панели
            var observer = new MutationObserver(function() {
                updatePanelHeight(panel);
                addImageLoadListeners(panel);
            });

            // Настраиваем наблюдатель на отслеживание изменений в дочерних элементах
            observer.observe(panel, { childList: true, subtree: true });

            // Добавляем обработчики загрузки изображений
            addImageLoadListeners(panel);
        }
    });

    // Добавляем обработчик событий для каждого элемента аккордеона
    acc.forEach(function(item) {
        item.addEventListener("click", function() {
            // Переключаем класс 'active' для текущего элемента
            item.classList.toggle("active");

            // Получаем следующую панель
            var panel = item.nextElementSibling;

            // Проверяем текущую высоту панели и устанавливаем новую
            if (panel.style.maxHeight) {
                setPanelHeight(panel, null);
            } else {
                setPanelHeight(panel, panel.scrollHeight + "px");

                // Создаем MutationObserver для отслеживания изменений в панели
                var observer = new MutationObserver(function() {
                    updatePanelHeight(panel);
                    addImageLoadListeners(panel);
                });

                // Настраиваем наблюдатель на отслеживание изменений в дочерних элементах
                observer.observe(panel, { childList: true, subtree: true });

                // Добавляем обработчики загрузки изображений
                addImageLoadListeners(panel);
            }
        });
    });
});
var loadedAnalitics = false, // Индикатор того, что вся аналитика уже загрузилась
    metricaId     = 100171544, // номер счетчика в Яндекс Метрике
    metricaSrc    = '/templates/atlant/js/metrika.js', // путь к скрипту Яндекс Метрике
    googleId      = 'G-8SNWHQYGJ6', // номер счетчика в Google Аналитике
    GoogleSrc     = '/templates/atlant/js/google.js', // путь к скрипту GA
    timerId; // Переменная для таймера

// Для ботов сервисов аналитики грузим счетчики сразу,
// чтобы в панели пройти проверку корректности установки
if (navigator.userAgent.indexOf('Yandex') > -1 || navigator.userAgent.indexOf('Google') > -1) {
    loadAnalitics();
} else {
    // Подключаем аналитику, если пользователь начал прокручивать страницу
    window.addEventListener('scroll', loadAnalitics, {passive: true});

    // Подключаем аналитику, если юзер коснулся экрана
    window.addEventListener( 'touchstart', loadAnalitics);

    // Подключаем аналитику, если юзер дернул мышкой
    document.addEventListener('mouseenter', loadAnalitics);

    // Подключаем аналитику, если юзер кликнул мышкой
    document.addEventListener('click', loadAnalitics);

    // Подключаем аналитику при полной загрузке DOM,
    // откладывая загрузку через setTimeout,
    // если ни одного из вышеперечисленных событий не произошло
    document.addEventListener('DOMContentLoaded', loadFallback);
    //document.addEventListener('DOMContentLoaded', loadBxFallback);
}

function loadFallback() {
    timerId = setTimeout(loadAnalitics, 300);
}

function Goal(ymGoal = '', gtagGoal = '', ttGoal = '', products = [], value = 0, phone = '') {
    if (ymGoal !== '') {
        ym(metricaId, 'reachGoal', ymGoal);
    }
    if (gtagGoal !== '') {
        gtag('event', gtagGoal);
    }
}

function PrepareElements(selector, ymGoal = '', gtagGoal = '', ttGoal = '', products = [], value = 0) {
    const elements = document.querySelectorAll(selector);
    elements.forEach(function (element) {
        element.addEventListener('click', (e) => {
            e.preventDefault(); // Предотвращаем стандартное поведение ссылки
            const href = element.getAttribute('href');

            // Проверяем наличие атрибута href
            if (!href) {
                console.warn('Нет атрибута href.');
                return;
            }

            Goal(ymGoal, gtagGoal, ttGoal, products, value);

            // Задержка перед переходом на новую страницу
            setTimeout(() => {
                const target = element.getAttribute('target');
                if (target === '_blank') {
                    window.open(href, '_blank'); // Открываем ссылку в новом окне
                } else {
                    window.location.href = href; // Открываем ссылку в текущем окне
                }
            }, 300); // 300 миллисекунд должно быть достаточно для отправки данных
        });
    });
}

window.dataLayer = window.dataLayer || [];
window.ym = window.ym || function () {
    (window.ym.a = window.ym.a || []).push(arguments)
}

function loadAnalitics() {
    // Если флаг загрузки аналитики отмечен,
    // то ничего более не делаем.
    if (loadedAnalitics) {
        return;
    }

    // Код Яндекс Метрики
    (function (m, e, t, r, i, k, a) {
        m[i] = m[i] || function () {
            (m[i].a = m[i].a || []).push(arguments)
        };
        m[i].l = 1 * new Date();
        k = e.createElement(t), a = e.getElementsByTagName(t)[0], k.async = true, k.src = r, a.parentNode.insertBefore(k, a)
    })
    (window, document, "script", metricaSrc, "ym");
    ym(metricaId, "init", {clickmap: true, trackLinks: true, accurateTrackBounce: true, ecommerce: "dataLayer"});

    // Код Google Аналитики
    var t = document.createElement("script");
    t.async = true;
    t.src = GoogleSrc;
    t.onload = function() {
        gtag('js', new Date());
        gtag('config', googleId);
    }
    document.head.appendChild(t);

    // Устанавливаем идентификатор клиента Яндекс
    ym(metricaId, 'getClientID', function (clientID) {
        //console.log(clientID);
        const metrika_inputs = document.querySelectorAll('input[name="metrika_client_id"]');
        metrika_inputs.forEach(function (input) {
            input.value = clientID;
        });
    });
    // Устанавливаем идентификатор клиента Google
    gtag('get', googleId, 'client_id', function(client_id) {
        //console.log(client_id);
        const google_inputs = document.querySelectorAll('input[name="google_client_id"]');
        google_inputs.forEach(function (input) {
            input.value = client_id;
        });
    });

    // ********************************************
    // Отмечаем флаг, что аналитика уже загрузилась,
    // чтобы не загружать её повторно при других
    // событиях пользователя и старте фоллбэка.
    loadedAnalitics = true;

    // Очищаем таймер
    clearTimeout(timerId);

    // Очищаем все слушатели событий
    window.removeEventListener( 'scroll', loadAnalitics );
    window.removeEventListener( 'touchstart', loadAnalitics );
    document.removeEventListener( 'mouseenter', loadAnalitics );
    document.removeEventListener( 'click', loadAnalitics );
    document.removeEventListener( 'DOMContentLoaded', loadFallback );

    // Отслеживаем клики
    PrepareElements("a[href^='tel']", 'PHONE', 'PHONE_CLICK');
    PrepareElements("a[href^='mailto']", 'EMAIL', 'EMAIL_CLICK');
    PrepareElements("a[href^='viber']", 'VIBER', 'VIBER_CLICK');
    PrepareElements("a[href^='https://t.me/']", 'TELEGRAM', 'TELEGRAM_CLICK');
    PrepareElements("a[href^='https://vk.com/']", 'VK_CLICK', 'VK_CLICK');
    PrepareElements("a[href^='https://ok.ru/']", 'OK_CLICK', 'OK_CLICK');
    PrepareElements("a[href^='https://yandex.ru/maps/']", 'GET_MAP', 'GET_MAP');
    PrepareElements("a[href^='https://www.wildberries']", 'GET_WB', 'GET_WB');
}
// быстрые результаты поиска
const ajaxSearchForm = document.querySelector('form.search');
const searchSagest = ajaxSearchForm.querySelector('form.search .sagest');
// если есть форма поиска
if (!!ajaxSearchForm && !!searchSagest) {
	// ищем поле для ввода запроса
	const ajaxSearchInput = ajaxSearchForm.querySelector('input[name=q]');

	ajaxSearchInput.addEventListener('focus', () => {
		const results = searchSagest.querySelectorAll('div');
		if (results.length > 0) {
			ajaxSearchForm.classList.add('show');
			document.addEventListener('click', (e) => sagestOutClick(e, ajaxSearchForm));
		}
	});

	if (!!ajaxSearchInput) {
		// вешаем обработчики изменения поля input
		ajaxSearchInput.addEventListener('input', ()=> getSearch(ajaxSearchInput));
	}
}

function getSearch(input) {
	if (input.value.length > 3) {
		getAjaxResult(input.value);
	}
}

function getAjaxResult(query) {
	const xhr = new XMLHttpRequest();
	xhr.open('POST', '/?option=com_finder&task=json.getjson&format=json&q=' + query, true);
	xhr.setRequestHeader('Cache-Control', 'no-cache');

	xhr.addEventListener("readystatechange", () => {
		if (xhr.readyState !== XMLHttpRequest.DONE) {
			return;
		}

		if (xhr.status === 200) {
			//console.log(xhr.responseText);
			const data = JSON.parse(xhr.responseText);
			//console.log(data);

			if (data.products.length > 0) {
				searchSagest.textContent = '';
				data.products.forEach((product) => {
					const div = document.createElement('div');
					const imgDiv = document.createElement('div');
					const title = document.createElement('h3');
					//const price = document.createElement('span');
					const url = document.createElement('a');


					title.textContent = product.title;
					//price.textContent = product.formatPrice;
					url.setAttribute('href', product.route);

					if (product.image !== '') {
						const img = document.createElement('img');
						img.setAttribute('src', product.image);
						img.setAttribute('alt', product.title);
						imgDiv.append(img);
					} else {
						// Создаем элемент <svg>
						const img = document.createElementNS("http://www.w3.org/2000/svg", "svg");
						img.setAttribute("class", "svg");
						// Создаем элемент <use>
						const useElement = document.createElementNS("http://www.w3.org/2000/svg", "use");
						useElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", "/ic.svg#image");
						// Вставляем элемент <use> внутрь элемента <svg>
						img.appendChild(useElement);
						imgDiv.append(img);
					}

					div.append(imgDiv, title, url);
					searchSagest.append(div);
					ajaxSearchForm.classList.add('show');
					document.addEventListener('click', (e) => sagestOutClick(e, ajaxSearchForm));
				})
			}
		}
	});
	xhr.send();
}

function sagestOutClick(event, ajaxSearchForm) {
	if (!ajaxSearchForm.contains(event.target)) {
		ajaxSearchForm.classList.remove('show');
		document.removeEventListener('click', sagestOutClick);
	}
}
{
    const shipping_buttons = document.querySelectorAll('.checkout_form_shipping');
    const payment_buttons = document.querySelectorAll('.checkout_form_payment');
    const input_address = document.querySelector('.input-row-address');
    const input_points = document.querySelector('.input-row-points');
    const input_shipping = document.querySelector('input[name=shipping]');
    const input_payment = document.querySelector('input[name=payment]');

    if (shipping_buttons.length > 0) {
        shipping_buttons.forEach(function(button) {
            button.addEventListener('click', function(event) {
                event.preventDefault();
                shipping_buttons.forEach(function(btn) {
                    btn.classList.remove('active');
                });
                button.classList.toggle('active');

                const input_shipping_value = button.querySelector('.checkout_form_shipping_name');

                if (!!input_shipping && !!input_shipping_value) {
                    input_shipping.value = input_shipping_value.textContent;
                }

                if (!!input_address) {
                    if (button.dataset.key !== '0') {
                        input_address.classList.add('d-n');
                    } else {
                        input_address.classList.remove('d-n');
                    }
                }

                if (!!input_points) {
                    if (button.dataset.key === '1') {
                        input_points.classList.remove('d-n');
                    } else {
                        input_points.classList.add('d-n');
                    }
                }
            });
        });
    }

    if (payment_buttons.length > 0) {
        payment_buttons.forEach(function(button) {
            button.addEventListener('click', function(event) {
                event.preventDefault();
                payment_buttons.forEach(function(btn) {
                    btn.classList.remove('active');
                });
                button.classList.toggle('active');

                const input_payment_value = button.querySelector('.checkout_form_payment_name');

                if (!!input_payment && !!input_payment_value) {
                    input_payment.value = input_payment_value.textContent;
                }
            });
        });
    }

    // отправка формы заказа
    const checkout_form = document.getElementById('checkout_form');
    if (!!checkout_form) {
        checkout_form.addEventListener('submit', function (event) {
            event.preventDefault();
            event.stopPropagation();

            const button = checkout_form.querySelector('[type="submit"]');
            const tokens = checkout_form.querySelectorAll('[value="1"]');
            let jtoken = '';
            const form_data = new FormData(checkout_form);

            //ищем токен формы
            tokens.forEach(function (input) {
                if (input.type === 'hidden' && input.name.length === 32) {
                    jtoken = input.name;
                }
            });

            // создаем иконку загрузки
            const spinner = document.createElement('i');
            spinner.classList.add('spinner');
            button.appendChild(spinner);

            // если поля заполнены верно
            if (!Validate(checkout_form)) {
                const xhr = new XMLHttpRequest();
                xhr.open('POST', '?option=com_ajax&module=iform&format=json', true);
                xhr.setRequestHeader('X-CSRF-Token', jtoken);
                xhr.setRequestHeader('Cache-Control', 'no-cache');

                xhr.addEventListener("readystatechange", () => {
                    if (xhr.readyState !== XMLHttpRequest.DONE) {
                        return;
                    }

                    if (xhr.status === 200) {
                        const data = JSON.parse(xhr.responseText);
                        checkoutUpdate(checkout_form, data);

                        if (data.data.errors.length === 0) {
                            try {
                                const params = JSON.parse(form_data.get('products'));
                                let productsLayer = [];

                                params.forEach(item => {
                                    productsLayer.push({
                                        item_id: item.product_id,
                                        item_name: item.product_name,
                                        price: item.price,
                                        item_brand: 'Atlant',
                                        quantity: item.quantity,
                                    });
                                });

                                gtag("event", "purchase", {
                                    transaction_id: Date.now().toString(16),
                                    value: form_data.get('total'),
                                    shipping: 0,
                                    currency: 'RUB',
                                    items: productsLayer
                                });

                            } catch (e) {
                                console.log('Error goal[ORDER]');
                            }

                            checkout_form.reset();
                            checkout_form.classList.add('d-n');
                            clearCart();
                            document.querySelector('.form_thank_you').classList.add('active');
                        }
                    }

                    setTimeout(() => {
                        spinner.remove();
                    }, 300);
                });
                xhr.send(form_data);
            }
        });
    }
}

// Обновляем статусы полей в форме
function checkoutUpdate(form, data) {
    if (data.data.errors.length !== 0) {
        data.data.errors.forEach(function (error) {
            if (error.key !== 'header') {
                const input = form.querySelector('[name="' + error.key + '"]');
                input.classList.add('danger');
            }
        });
    }

    if (data.data.valid.length !== 0) {
        data.data.valid.forEach(function (valid) {
            const input = form.querySelector('[name="' + valid + '"]');
            input.classList.add('success');
        });
    }
}
function clearCart() {
	const url = '/index.php?option=com_jshopping&controller=cart&task=clear&ajax=1';
	const request = new XMLHttpRequest();
	request.open('POST', url, true);
	request.send();
	updateCart(0);
}
// Кнопка очистки списка сравнения
const compare_clear_button = document.querySelector('[data-compare-clear]') ?? false;

if (compare_clear_button !== false) {
    // Контейнер модуля сравнения
    const compare_module = compare_clear_button.parentNode ?? false;
    // Элемент с числом товаров в списке
    const compare_count = compare_module.querySelector('.link > span') ?? false;

    // Добавление в список сравнения
    const compare_buttons = document.querySelectorAll('[data-compare]');
    if (compare_buttons.length > 0) {
        compare_buttons.forEach(function(button) {
            button.addEventListener('click', function(event) {
                event.preventDefault();
                const product_id = button.dataset.compare;
                const isActive = button.classList.contains('active');
                const task = isActive ? 'compare.removeFromCompare' : 'compare.addToCompare';

                const xhr = new XMLHttpRequest();
                xhr.open('POST', '/index.php?option=com_izoomos&task=' + task + '&format=json&tmpl=component&product_id=' + product_id, true);
                xhr.setRequestHeader('Cache-Control', 'no-cache');

                xhr.addEventListener("readystatechange", () => {
                    if (xhr.readyState !== XMLHttpRequest.DONE) {
                        return;
                    }

                    if (xhr.status === 200) {
                        const data = JSON.parse(xhr.responseText);
                        //console.log(data);

                        if (data.success && data.message !== '') {
                            // Переключаем класс active
                            button.classList.toggle('active');
                            button.querySelector('span').textContent = data.message;

                            // Меняем число товаров в списке
                            compare_count.textContent = data.data;
                            // Если список пуст - скрываем модуль сравнения
                            if (data.data === 0) {
                                compare_module.classList.remove('active');
                            } else if (data.data === 1) {
                                compare_module.classList.add('active');
                            }

                            if (!isActive) {
                                Goal('TO_COMPARE', 'TO_COMPARE');
                            }
                        }
                    }
                });
                xhr.send();
            });
        });
    }

    // Очистка списка сравнения
    compare_clear_button.addEventListener('click', function(event) {
        event.preventDefault();

        const xhr = new XMLHttpRequest();
        xhr.open('POST', '/index.php?option=com_izoomos&task=compare.clear&format=json&tmpl=component', true);
        xhr.setRequestHeader('Cache-Control', 'no-cache');
        xhr.addEventListener("readystatechange", () => {
            if (xhr.readyState !== XMLHttpRequest.DONE) {
                return;
            }

            if (xhr.status === 200) {
                const data = JSON.parse(xhr.responseText);
                //console.log(data);

                if (data.success && data.message !== '') {
                    // Меняем число товаров в списке
                    compare_count.textContent = data.data;
                    // Скрываем модуль сравнения
                    compare_module.classList.remove('active');

                    // Снимаем классы со всех кнопок и меняем текст
                    compare_buttons.forEach(function(button) {
                        button.classList.remove('active');
                        button.querySelector('span').textContent = data.message;
                    });
                }
            }
        });
        xhr.send();
    });
}
const dataLayerSelectsButtons = document.querySelectorAll('[data-layer-select]');
if (dataLayerSelectsButtons.length > 0) {
    dataLayerSelectsButtons.forEach((button) => {
        button.addEventListener('click', (e) => {
            e.preventDefault(); // Предотвращаем стандартное поведение ссылки
            const href = button.getAttribute('href');

            // Проверяем наличие атрибута href
            if (!href) {
                console.warn('Нет атрибута href.');
                return;
            }

            let data;
            try {
                data = JSON.parse(button.dataset.layerSelect);
            } catch (error) {
                console.error('Невалидный JSON: ', button.dataset.layerSelect);
                return;
            }

            gtag("event", "select_item", {items: [data]});

            // Задержка перед переходом на новую страницу
            setTimeout(() => {
                window.location.href = href;
            }, 300); // 300 миллисекунд должно быть достаточно для отправки данных
        });
    });
}
function declension(number, titles) {
    let abs = Math.abs(number);
    let cases = [2, 0, 1, 1, 1, 2];
    return titles[(abs % 100 > 4 && abs % 100 < 20) ? 2 : cases[Math.min(abs % 10, 5)]];
}
function deleteProduct(id, btn, current, product) {
	if (!id || !btn) {
		return;
	}

	const url = '/index.php?option=com_jshopping&controller=cart&task=delete&ajax=1&number_id=' + id;
	const request = new XMLHttpRequest();
	const spinner = document.createElement('i');
	spinner.classList.add('spinner');
	btn.appendChild(spinner);

	request.open('POST', url, true);
	request.addEventListener('readystatechange', () => {
		if (request.readyState === XMLHttpRequest.DONE) {
			if (request.status === 200) {
				const response = JSON.parse(request.responseText);
				//console.log(response.count_product);

				const cart = document.getElementById('cartForm');
				cart.querySelector('.in_cart_total').textContent = response.price_product + ' руб';
				updateCart(response.count_product);
				current.remove();

				// Электронная коммерция
				gtag("event", "remove_from_cart", {
					items: [{
						item_name: product.product_name,
						item_id: product.product_id,
						price: product.price,
						item_brand: 'Atlant',
						index: product.index,
						quantity: product.quantity
					}]});
			}

			setTimeout(() => {
				spinner.remove();
			}, 300);
		}
	});
	request.send();
}

{
	const btns_delete = document.querySelectorAll('[data-delete]');
	if (btns_delete.length > 0) {
		btns_delete.forEach(function(btn) {
			btn.addEventListener('click', (evt) => {
				evt.preventDefault();
				evt.stopPropagation();
				const current = btn.closest('[data-productid]');
				const product = JSON.parse(btn.dataset.delete);
				deleteProduct(current.dataset.key, btn, current, product);
				return false;
			});
		});
	}
}
function discountCart(form, btn, code) {
	if (!form || !btn || !code) {
		return;
	}

	const url = '/index.php?option=com_jshopping&controller=cart&task=discountsave&ajax=1';
	const request = new XMLHttpRequest();
	const params = new FormData();
	params.append('rabatt', code);

	const spinner = document.createElement('i');
	spinner.classList.add('spinner');
	btn.appendChild(spinner);

	request.open('POST', url, true);
	request.addEventListener('readystatechange', () => {
		if (request.readyState === XMLHttpRequest.DONE) {
			if (request.status === 200) {
				const response = JSON.parse(request.responseText);
			}

			setTimeout(() => {
				spinner.remove();
			}, 300);
		}
	});
	request.send();
}

const discountForm = document.querySelector('#discountForm');
if (discountForm) {
	const discountCode = discountForm.querySelector('input');
	const discountBtn = discountForm.querySelector('button');
	{
		discountBtn.addEventListener('click', (evt) => {
			evt.preventDefault();
			evt.stopPropagation();
			discountCart(discountForm, discountBtn, discountCode.value);
			return false;
		});
	}
}
{
    const dropdownToggle = document.querySelector('.dropdown-toggle');
    const dropdownMenu = document.querySelector('.dropdown-menu');

    if (!!dropdownToggle && !!dropdownMenu) {
        dropdownToggle.addEventListener('click', function() {
            dropdownMenu.classList.toggle('active');
        });

        // Close the dropdown menu if the user clicks outside of it
        window.addEventListener('click', function(event) {
            if (!dropdownToggle.contains(event.target)) {
                dropdownMenu.classList.remove('active');
            }
        });

        const dropdownLinks = document.querySelectorAll('.dropdown-menu span');
        if (dropdownLinks.length > 0) {
            dropdownLinks.forEach(function(link) {
                link.addEventListener('click', function(event) {
                    event.preventDefault();
                    dropdownToggle.textContent = link.textContent;
                    dropdownMenu.classList.remove('active');
                });
            });
        }
    }
}
function iFilterClear(form = 'ifilter') {
    var formElement = document.querySelector('form[name=' + form + ']');
    if (formElement.length > 0) {
        formElement.querySelectorAll('input[type=text]').forEach(function(input) {
            input.value = '';
        });

        formElement.querySelectorAll('input[type=number]').forEach(function(input) {
            input.value = '';
        });

        formElement.querySelectorAll('input[type=checkbox]').forEach(function(input) {
            input.removeAttribute('checked');
        });

        formElement.submit();
    }
}
const switchers = document.querySelectorAll('.form-switcher');

switchers.forEach(switcher => {
    const input = switcher.querySelector('input');

    switcher.addEventListener('click', function() {
        input.checked = !input.checked;
        switcher.classList.toggle('checked', input.checked);
    });
});
/*! lozad.js - v1.16.0 - 2020-09-10
* https://github.com/ApoorvSaxena/lozad.js
* Copyright (c) 2020 Apoorv Saxena; Licensed MIT */


(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
        typeof define === 'function' && define.amd ? define(factory) :
            (global.lozad = factory());
}(this, (function () { 'use strict';

    /**
     * Detect IE browser
     * @const {boolean}
     * @private
     */
    var isIE = typeof document !== 'undefined' && document.documentMode;

    /**
     *
     * @param {string} type
     *
     */
    var support = function support(type) {
        return window && window[type];
    };

    var validAttribute = ['data-iesrc', 'data-alt', 'data-src', 'data-srcset', 'data-background-image', 'data-toggle-class'];

    var defaultConfig = {
        rootMargin: '0px',
        threshold: 0,
        enableAutoReload: false,
        load: function load(element) {
            if (element.nodeName.toLowerCase() === 'picture') {
                var img = element.querySelector('img');
                var append = false;

                if (img === null) {
                    img = document.createElement('img');
                    append = true;
                }

                if (isIE && element.getAttribute('data-iesrc')) {
                    img.src = element.getAttribute('data-iesrc');
                }

                if (element.getAttribute('data-alt')) {
                    img.alt = element.getAttribute('data-alt');
                }

                if (append) {
                    element.append(img);
                }
            }

            if (element.nodeName.toLowerCase() === 'video' && !element.getAttribute('data-src')) {
                if (element.children) {
                    var childs = element.children;
                    var childSrc = void 0;
                    for (var i = 0; i <= childs.length - 1; i++) {
                        childSrc = childs[i].getAttribute('data-src');
                        if (childSrc) {
                            childs[i].src = childSrc;
                        }
                    }

                    element.load();
                }
            }

            if (element.getAttribute('data-poster')) {
                element.poster = element.getAttribute('data-poster');
            }

            if (element.getAttribute('data-src')) {
                element.src = element.getAttribute('data-src');
            }

            if (element.getAttribute('data-srcset')) {
                element.setAttribute('srcset', element.getAttribute('data-srcset'));
            }

            var backgroundImageDelimiter = ',';
            if (element.getAttribute('data-background-delimiter')) {
                backgroundImageDelimiter = element.getAttribute('data-background-delimiter');
            }

            if (element.getAttribute('data-background-image')) {
                element.style.backgroundImage = 'url(\'' + element.getAttribute('data-background-image').split(backgroundImageDelimiter).join('\'),url(\'') + '\')';
            } else if (element.getAttribute('data-background-image-set')) {
                var imageSetLinks = element.getAttribute('data-background-image-set').split(backgroundImageDelimiter);
                var firstUrlLink = imageSetLinks[0].substr(0, imageSetLinks[0].indexOf(' ')) || imageSetLinks[0]; // Substring before ... 1x
                firstUrlLink = firstUrlLink.indexOf('url(') === -1 ? 'url(' + firstUrlLink + ')' : firstUrlLink;
                if (imageSetLinks.length === 1) {
                    element.style.backgroundImage = firstUrlLink;
                } else {
                    element.setAttribute('style', (element.getAttribute('style') || '') + ('background-image: ' + firstUrlLink + '; background-image: -webkit-image-set(' + imageSetLinks + '); background-image: image-set(' + imageSetLinks + ')'));
                }
            }

            if (element.getAttribute('data-toggle-class')) {
                element.classList.toggle(element.getAttribute('data-toggle-class'));
            }
        },
        loaded: function loaded() {}
    };

    function markAsLoaded(element) {
        element.setAttribute('data-loaded', true);
    }

    function preLoad(element) {
        if (element.getAttribute('data-placeholder-background')) {
            element.style.background = element.getAttribute('data-placeholder-background');
        }
    }

    var isLoaded = function isLoaded(element) {
        return element.getAttribute('data-loaded') === 'true';
    };

    var onIntersection = function onIntersection(load, loaded) {
        return function (entries, observer) {
            entries.forEach(function (entry) {
                if (entry.intersectionRatio > 0 || entry.isIntersecting) {
                    observer.unobserve(entry.target);

                    if (!isLoaded(entry.target)) {
                        load(entry.target);
                        markAsLoaded(entry.target);
                        loaded(entry.target);
                    }
                }
            });
        };
    };

    var onMutation = function onMutation(load) {
        return function (entries) {
            entries.forEach(function (entry) {
                if (isLoaded(entry.target) && entry.type === 'attributes' && validAttribute.indexOf(entry.attributeName) > -1) {
                    load(entry.target);
                }
            });
        };
    };

    var getElements = function getElements(selector) {
        var root = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;

        if (selector instanceof Element) {
            return [selector];
        }

        if (selector instanceof NodeList) {
            return selector;
        }

        return root.querySelectorAll(selector);
    };

    function lozad () {
        var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.lozad';
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        var _Object$assign = Object.assign({}, defaultConfig, options),
            root = _Object$assign.root,
            rootMargin = _Object$assign.rootMargin,
            threshold = _Object$assign.threshold,
            enableAutoReload = _Object$assign.enableAutoReload,
            load = _Object$assign.load,
            loaded = _Object$assign.loaded;

        var observer = void 0;
        var mutationObserver = void 0;
        if (support('IntersectionObserver')) {
            observer = new IntersectionObserver(onIntersection(load, loaded), {
                root: root,
                rootMargin: rootMargin,
                threshold: threshold
            });
        }

        if (support('MutationObserver') && enableAutoReload) {
            mutationObserver = new MutationObserver(onMutation(load, loaded));
        }

        var elements = getElements(selector, root);
        for (var i = 0; i < elements.length; i++) {
            preLoad(elements[i]);
        }

        return {
            observe: function observe() {
                var elements = getElements(selector, root);

                for (var _i = 0; _i < elements.length; _i++) {
                    if (isLoaded(elements[_i])) {
                        continue;
                    }

                    if (observer) {
                        if (mutationObserver && enableAutoReload) {
                            mutationObserver.observe(elements[_i], { subtree: true, attributes: true, attributeFilter: validAttribute });
                        }

                        observer.observe(elements[_i]);
                        continue;
                    }

                    load(elements[_i]);
                    markAsLoaded(elements[_i]);
                    loaded(elements[_i]);
                }
            },
            triggerLoad: function triggerLoad(element) {
                if (isLoaded(element)) {
                    return;
                }

                load(element);
                markAsLoaded(element);
                loaded(element);
            },

            observer: observer,
            mutationObserver: mutationObserver
        };
    }

    return lozad;

})));

(function () {
    lozad('img[data-srcset]', {
        rootMargin: '300px 500px',
        threshold: 0.1,
        enableAutoReload: true
    }).observe();

    lozad('img[data-src]', {
        rootMargin: '300px 500px',
        threshold: 0.1,
        enableAutoReload: true
    }).observe();

    // lozad('iframe[data-src]', {
    //     rootMargin: '10px 0px',
    //     threshold: 0.1,
    //     enableAutoReload: true
    // }).observe();
}());
(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    define(factory);
  } else if (typeof exports === 'object') {
    module.exports = factory();
  } else {
    root.VMasker = factory();
  }
}(this, function() {
  var DIGIT = "9",
      ALPHA = "A",
      ALPHANUM = "S",
      BY_PASS_KEYS = [9, 16, 17, 18, 36, 37, 38, 39, 40, 91, 92, 93],
      isAllowedKeyCode = function(keyCode) {
        for (var i = 0, len = BY_PASS_KEYS.length; i < len; i++) {
          if (keyCode == BY_PASS_KEYS[i]) {
            return false;
          }
        }
        return true;
      },
      mergeMoneyOptions = function(opts) {
        opts = opts || {};
        opts = {
          precision: opts.hasOwnProperty("precision") ? opts.precision : 2,
          separator: opts.separator || ",",
          delimiter: opts.delimiter || ".",
          unit: opts.unit && (opts.unit.replace(/[\s]/g,'') + " ") || "",
          suffixUnit: opts.suffixUnit && (" " + opts.suffixUnit.replace(/[\s]/g,'')) || "",
          zeroCents: opts.zeroCents,
          lastOutput: opts.lastOutput
        };
        opts.moneyPrecision = opts.zeroCents ? 0 : opts.precision;
        return opts;
      },
      // Fill wildcards past index in output with placeholder
      addPlaceholdersToOutput = function(output, index, placeholder) {
        for (; index < output.length; index++) {
          if(output[index] === DIGIT || output[index] === ALPHA || output[index] === ALPHANUM) {
            output[index] = placeholder;
          }
        }
        return output;
      }
  ;

  var VanillaMasker = function(elements) {
    this.elements = elements;
  };

  VanillaMasker.prototype.unbindElementToMask = function() {
    for (var i = 0, len = this.elements.length; i < len; i++) {
      this.elements[i].lastOutput = "";
      this.elements[i].onkeyup = false;
      this.elements[i].onkeydown = false;

      if (this.elements[i].value.length) {
        this.elements[i].value = this.elements[i].value.replace(/\D/g, '');
      }
    }
  };

  VanillaMasker.prototype.bindElementToMask = function(maskFunction) {
    var that = this,
        onType = function(e) {
          e = e || window.event;
          var source = e.target || e.srcElement;

          if (isAllowedKeyCode(e.keyCode)) {
            setTimeout(function() {
              that.opts.lastOutput = source.lastOutput;
              source.value = VMasker[maskFunction](source.value, that.opts);
              source.lastOutput = source.value;
              if (source.setSelectionRange && that.opts.suffixUnit) {
                source.setSelectionRange(source.value.length, (source.value.length - that.opts.suffixUnit.length));
              }
            }, 0);
          }
        }
    ;
    for (var i = 0, len = this.elements.length; i < len; i++) {
      this.elements[i].lastOutput = "";
      this.elements[i].onkeyup = onType;
      if (this.elements[i].value.length) {
        this.elements[i].value = VMasker[maskFunction](this.elements[i].value, this.opts);
      }
    }
  };

  VanillaMasker.prototype.maskMoney = function(opts) {
    this.opts = mergeMoneyOptions(opts);
    this.bindElementToMask("toMoney");
  };

  VanillaMasker.prototype.maskNumber = function() {
    this.opts = {};
    this.bindElementToMask("toNumber");
  };
  
  VanillaMasker.prototype.maskAlphaNum = function() {
    this.opts = {};
    this.bindElementToMask("toAlphaNumeric");
  };

  VanillaMasker.prototype.maskPattern = function(pattern) {
    this.opts = {pattern: pattern};
    this.bindElementToMask("toPattern");
  };

  VanillaMasker.prototype.unMask = function() {
    this.unbindElementToMask();
  };

  var VMasker = function(el) {
    if (!el) {
      throw new Error("VanillaMasker: There is no element to bind.");
    }
    var elements = ("length" in el) ? (el.length ? el : []) : [el];
    return new VanillaMasker(elements);
  };

  VMasker.toMoney = function(value, opts) {
    opts = mergeMoneyOptions(opts);
    if (opts.zeroCents) {
      opts.lastOutput = opts.lastOutput || "";
      var zeroMatcher = ("("+ opts.separator +"[0]{0,"+ opts.precision +"})"),
          zeroRegExp = new RegExp(zeroMatcher, "g"),
          digitsLength = value.toString().replace(/[\D]/g, "").length || 0,
          lastDigitLength = opts.lastOutput.toString().replace(/[\D]/g, "").length || 0
      ;
      value = value.toString().replace(zeroRegExp, "");
      if (digitsLength < lastDigitLength) {
        value = value.slice(0, value.length - 1);
      }
    }
    var number = value.toString().replace(/[\D]/g, ""),
        clearDelimiter = new RegExp("^(0|\\"+ opts.delimiter +")"),
        clearSeparator = new RegExp("(\\"+ opts.separator +")$"),
        money = number.substr(0, number.length - opts.moneyPrecision),
        masked = money.substr(0, money.length % 3),
        cents = new Array(opts.precision + 1).join("0")
    ;
    money = money.substr(money.length % 3, money.length);
    for (var i = 0, len = money.length; i < len; i++) {
      if (i % 3 === 0) {
        masked += opts.delimiter;
      }
      masked += money[i];
    }
    masked = masked.replace(clearDelimiter, "");
    masked = masked.length ? masked : "0";
    if (!opts.zeroCents) {
      var beginCents = number.length - opts.precision,
          centsValue = number.substr(beginCents, opts.precision),
          centsLength = centsValue.length,
          centsSliced = (opts.precision > centsLength) ? opts.precision : centsLength
      ;
      cents = (cents + centsValue).slice(-centsSliced);
    }
    var output = opts.unit + masked + opts.separator + cents + opts.suffixUnit;
    return output.replace(clearSeparator, "");
  };

  VMasker.toPattern = function(value, opts) {
    var pattern = (typeof opts === 'object' ? opts.pattern : opts),
        patternChars = pattern.replace(/\W/g, ''),
        output = pattern.split(""),
        values = value.toString().replace(/\W/g, ""),
        charsValues = values.replace(/\W/g, ''),
        index = 0,
        i,
        outputLength = output.length,
        placeholder = (typeof opts === 'object' ? opts.placeholder : undefined)
    ;
    
    for (i = 0; i < outputLength; i++) {
      // Reached the end of input
      if (index >= values.length) {
        if (patternChars.length == charsValues.length) {
          return output.join("");
        }
        else if ((placeholder !== undefined) && (patternChars.length > charsValues.length)) {
          return addPlaceholdersToOutput(output, i, placeholder).join("");
        }
        else {
          break;
        }
      }
      // Remaining chars in input
      else{
        if ((output[i] === DIGIT && values[index].match(/[0-9]/)) ||
            (output[i] === ALPHA && values[index].match(/[a-zA-Z]/)) ||
            (output[i] === ALPHANUM && values[index].match(/[0-9a-zA-Z]/))) {
          output[i] = values[index++];
        } else if (output[i] === DIGIT || output[i] === ALPHA || output[i] === ALPHANUM) {
          if(placeholder !== undefined){
            return addPlaceholdersToOutput(output, i, placeholder).join("");
          }
          else{
            return output.slice(0, i).join("");
          }
        }
      }
    }
    return output.join("").substr(0, i);
  };

  VMasker.toNumber = function(value) {
    return value.toString().replace(/(?!^-)[^0-9]/g, "");
  };
  
  VMasker.toAlphaNumeric = function(value) {
    return value.toString().replace(/[^a-z0-9 ]+/i, "");
  };

  return VMasker;
}));


const phones = document.querySelectorAll("input.required-phone");
phones.forEach(function(item) {
  VMasker(item).maskPattern("+9 (999) 999-99-99-999");
});
function modalOpen(pup, type = null) {
    document.body.classList.add('opnd');

    if (type === 'img') {
    }

    pup.classList.add('active');
}

function modalClose(pup, type = null) {
    document.body.classList.remove('opnd');

    if (type === 'img') {
        pup.querySelector('img').remove();
    }

    pup.classList.remove('active');
}

(function () {
    const mainpup = document.getElementById('modal');
    if (!!mainpup) {
        const pupin = mainpup.querySelector('.modal_inner');
        let type = 'empty';
        document.querySelectorAll('[data-modal]').forEach((button) => {
            // Перебираем все кнопки
            button.addEventListener('click', (e) => {
                e.preventDefault(); // Предотвращаем дефолтное поведение

                if (button.tagName === 'IMG') {
                    let img = document.createElement('img');
                    img.setAttribute('src', button.getAttribute('src'));
                    mainpup.querySelector('.modal_inner').appendChild(img);
                    type = 'img';
                }

                modalOpen(mainpup, type);
            })
        });

        const closeBtn = mainpup.querySelector('.modal_close');
        closeBtn.addEventListener('click',(e) => {
            e.preventDefault(); // Предотвращаем дефолтное поведение
            modalClose(mainpup, type);
        });

        document.addEventListener('click', (e) => {
            if (e.target === pupin) {
                modalClose(mainpup, type);
            }
        });
    }
}());
const oneClickModal = document.getElementById('modal_1click');
if (!!oneClickModal) {
    const modal_inner = oneClickModal.querySelector('.modal_inner');
    const modalButtons= document.querySelectorAll('[data-one-click]');
    if (modalButtons.length > 0) {
        modalButtons.forEach((button) => {
            button.addEventListener('click', (e) => {
                e.preventDefault(); // Предотвращаем дефолтное поведение
                const data = button.parentNode.dataset.modal1click;
                const params = JSON.parse(data)[0];

                modal_inner.querySelector('form').classList.remove('d-n');
                modal_inner.querySelector('.form_thank_you').classList.remove('active');

                // установить изображение
                const img = document.getElementById('1click-img');
                img.textContent = '';

                if (params.img !== '') {
                    const image = document.createElement('img');
                    image.setAttribute('src', params.img);
                    image.setAttribute('alt', params.title);
                    img.appendChild(image);
                } else {
                    // Создаем элемент <svg>
                    const image = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                    image.setAttribute("class", "svg mega");
                    // Создаем элемент <use>
                    const useElement = document.createElementNS("http://www.w3.org/2000/svg", "use");
                    useElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", "/ic.svg#image");
                    // Вставляем элемент <use> внутрь элемента <svg>
                    image.appendChild(useElement);
                    img.appendChild(image);
                }

                // установить заголовок
                const title = document.getElementById('1click-title');
                let tmpTitle = params.title.replace(/&quot;/g, '\"');
                tmpTitle = tmpTitle.replace(/&#039;/g, "'");
                title.textContent = tmpTitle;
                document.getElementById('1click-title-ty').textContent = params.title;

                // установить старую цену
                const old = document.getElementById('1click-old');
                old.textContent = '';
                if (params.old != 0) {
                    old.textContent = params.format_old;
                }

                // установить реальную цену
                const price = document.getElementById('1click-price');
                price.textContent = '';
                if (params.format_price != 0) {
                    price.textContent = params.format_price;
                    document.getElementById('1click-price-ty').textContent = params.format_price;
                } else {
                    document.getElementById('1click-price-ty').textContent = '';
                }

                // установить input поля
                modal_inner.querySelector('input[name="products"]').setAttribute('value', data);
                modal_inner.querySelector('input[name="total"]').setAttribute('value', params.price);

                modalOpen(oneClickModal);
            });
        });
    }

    const closeBtn = oneClickModal.querySelector('.modal_close');
    closeBtn.addEventListener('click',(e) => {
        e.preventDefault(); // Предотвращаем дефолтное поведение
        modalClose(oneClickModal);
    });

    document.addEventListener('click', (e) => {
        if (e.target === modal_inner) {
            modalClose(oneClickModal);
        }
    });
}
function offClose(menu, evnt) {
    menu.classList.remove('open');
    document.body.classList.remove('opnd');
    if (!menu.classList.contains('login')) {
        const main = menu.querySelector('nav > ul');
        openPanel(main, main, evnt);
    }

    evnt.stopImmediatePropagation();
}

function offOpen(menu, evnt) {
    menu.classList.add('open');
    document.body.classList.add('opnd');
    evnt.stopImmediatePropagation();
}

function openPanel(panel, main, evnt) {
    const nodes = main.querySelectorAll('.open');
    let title = main.parentElement.dataset.title;

    //  Opening the main level UL.
    if (panel === main) {
        main.parentElement.classList.add('main');
    } else { //  Opening a sub level UL.
        let children = Array.from(panel.parentElement.children);
        main.parentElement.classList.remove('main');
        children.forEach(function(ch) {
            if (ch.matches('a, span')) {
                title = ch.textContent.trim();
            }
        });
    }

    //  Set the title.
    main.parentElement.querySelector('.back').innerText = title;

    //  Unset all panels from being opened and parent.
    nodes.forEach(open => {
        open.classList.remove('open');
        open.classList.remove('parent');
    });

    //  Set the current panel as being opened.
    panel.classList.add('open');
    panel.classList.remove('parent');

    //  Set all parent panels as being parent.
    let parent = panel.parentElement.closest('ul');
    while (parent) {
        parent.classList.add('open');
        parent.classList.add('parent');
        parent = parent.parentElement.closest('ul');
    }

    evnt.stopImmediatePropagation();
}

{
    //открытие меню кнопкой (бургер)
    const offcanvas = document.querySelectorAll('[data-offcanvas]');
    offcanvas.forEach(function(item) {
        let menu = document.querySelector(item.getAttribute('href'));
        let bg = menu.querySelector('.offcanvas_bg');

        item.addEventListener('click', (evnt) => {
            //evnt.preventDefault();
            evnt.stopPropagation();
            offOpen(menu, evnt)
        }, {passive: true});
        bg.addEventListener('touchstart', (evnt) => {
            offClose(menu, evnt)
        }, {passive: true});
        bg.addEventListener('mousedown', (evnt) => {
            offClose(menu, evnt)
        }, {passive: true});

        if (!menu.classList.contains('login')) {
            const main = menu.querySelector('nav > ul');
            const back = menu.querySelector('nav > .back');
            const links = main.querySelectorAll('li.parent');

            back.addEventListener('click', (evnt) => {
                let panels = main.querySelectorAll('.open');
                let panel = panels[panels.length - 1];
                if (panel) {
                    // The second to last opened UL.
                    let parent = panel.parentElement.closest('ul');
                    if (parent) {
                        openPanel(parent, main, evnt);
                    }
                }
            }, {passive: true});

            links.forEach(function(item) {
                let panel = main;
                let children = Array.from(item.children);

                children.forEach(function(ch) {
                    if (ch.matches('ul')) {
                        panel = ch;
                    }
                });

                item.addEventListener('click', (evnt) => {
                    openPanel(panel, main, evnt)
                }, {passive: true});
            });
        }
    });
}
(function () {
    // Отступ на ширину скрола справа
    const padding = (window.innerWidth - document.documentElement.clientWidth) + 'px';
    document.body.style.paddingRight = padding;
    ////document.getElementById('header').style.paddingRight = padding;
}());
// Получаем список элементов с атрибутом калькулятора
const calculators = document.querySelectorAll('[data-parts-calculate]');
// Если нашлись элементы с калькулятором, обходим их по одному
if (calculators.length > 0) {
    calculators.forEach((calcContainer) => {
        // Получаем список радио кнопок для выбора срока кредитования
        const inputs = calcContainer.querySelectorAll('input[type=radio]');

        // Если нашлись такие кнопки, вешаем на них обработчики
        if (inputs.length > 0) {
            inputs.forEach((radioButton) => {
                radioButton.addEventListener('click', () => {
                    // получаем параметры из значения поля
                    let params;
                    try {
                        params = JSON.parse(radioButton.value);
                    } catch (error) {
                        console.error('Ошибка при разборе JSON:', error);
                        return;
                    }

                    const elPrice = calcContainer.querySelector('.parts-calculate-content-price');
                    const elFirst = calcContainer.querySelector('.parts-calculate-first');
                    const elOverPayment = calcContainer.querySelector('.parts-calculate-over-payment');
                    const elMonths = calcContainer.querySelector('.parts-calculate-months');
                    const elTotalPayment = calcContainer.querySelector('.parts-calculate-total-payment');

                    // Устанавливаем значения, если элементы существуют
                    if (elPrice) elPrice.textContent = params.monthlyPayment || '';
                    if (elFirst) elFirst.textContent = params.firstPay || '';
                    if (elOverPayment) elOverPayment.textContent = params.overPayment || '';
                    if (elMonths) elMonths.textContent = params.period || '';
                    if (elTotalPayment) elTotalPayment.textContent = params.totalPayment || '';
                });
            });
        }
    });
}
const sliders = document.querySelectorAll('.range');

sliders.forEach(slider => {
    const rangeMinInput = slider.querySelector('.range-min');
    const rangeMaxInput = slider.querySelector('.range-max');
    const rangeSlider = slider.querySelector('.range-slider');
    const rangeLine = slider.querySelector('.range-slider__line');
    const rangeUpperPoint = slider.querySelector('.range-slider__point--upper');
    const rangeLowerPoint = slider.querySelector('.range-slider__point--lower');

    const minPrice = parseInt(rangeMinInput.min);
    const maxPrice = parseInt(rangeMaxInput.max);

    let inputTimeout;

    function updateSlider() {
        const minValue = parseInt(rangeMinInput.value) || minPrice;
        const maxValue = parseInt(rangeMaxInput.value) || maxPrice;

        const minPercent = ((minValue - minPrice) / (maxPrice - minPrice)) * 100;
        const maxPercent = ((maxValue - minPrice) / (maxPrice - minPrice)) * 100;

        rangeLine.style.left = minPercent + '%';
        rangeLine.style.right = (100 - maxPercent) + '%';

        rangeUpperPoint.style.left = minPercent + '%';
        rangeLowerPoint.style.left = maxPercent + '%';

        // Ensure points do not overlap
        if (minValue === maxValue) {
            rangeUpperPoint.style.zIndex = 1;
            rangeLowerPoint.style.zIndex = 2;
        } else {
            rangeUpperPoint.style.zIndex = '';
            rangeLowerPoint.style.zIndex = '';
        }
    }

    function handleInputChange() {
        clearTimeout(inputTimeout);
        inputTimeout = setTimeout(() => {
            let minValue = parseInt(rangeMinInput.value);
            let maxValue = parseInt(rangeMaxInput.value);

            if (minValue < minPrice || isNaN(minValue)) {
                rangeMinInput.value = '';
                minValue = minPrice;
            }

            if (maxValue > maxPrice || isNaN(maxValue)) {
                rangeMaxInput.value = '';
                maxValue = maxPrice;
            }

            if (minValue > maxValue) {
                minValue = maxValue;
                rangeMinInput.value = minValue;
            }

            updateSlider();
        }, 500); // Задержка в 500 мс
    }

    function handleSliderMove(event, point) {
        const sliderRect = rangeSlider.getBoundingClientRect();
        const sliderWidth = sliderRect.width;
        const pointWidth = rangeUpperPoint.offsetWidth;
        const offsetX = (event.touches ? event.touches[0].clientX : event.clientX) - sliderRect.left;

        let newPercent = (offsetX / sliderWidth) * 100;
        newPercent = Math.max(0, Math.min(100, newPercent));

        const newValue = Math.round(minPrice + (newPercent / 100) * (maxPrice - minPrice));

        if (point === rangeUpperPoint) {
            const maxValue = parseInt(rangeMaxInput.value) || maxPrice;
            const maxPercent = ((maxValue - minPrice) / (maxPrice - minPrice)) * 100;
            if (newPercent > maxPercent - (pointWidth / sliderWidth) * 100) {
                rangeMinInput.value = Math.round(minPrice + (maxPercent - (pointWidth / sliderWidth) * 100) / 100 * (maxPrice - minPrice));
            } else {
                rangeMinInput.value = newValue;
            }
            if (newValue === minPrice) {
                rangeMinInput.value = '';
            }
        } else {
            const minValue = parseInt(rangeMinInput.value) || minPrice;
            const minPercent = ((minValue - minPrice) / (maxPrice - minPrice)) * 100;
            if (newPercent < minPercent + (pointWidth / sliderWidth) * 100) {
                rangeMaxInput.value = Math.round(minPrice + (minPercent + (pointWidth / sliderWidth) * 100) / 100 * (maxPrice - minPrice));
            } else {
                rangeMaxInput.value = newValue;
            }
            if (newValue === maxPrice) {
                rangeMaxInput.value = '';
            }
        }

        updateSlider();
    }

    function addEventListeners(point) {
        point.addEventListener('mousedown', function (event) {
            function onMouseMove(event) {
                handleSliderMove(event, point);
            }

            document.addEventListener('mousemove', onMouseMove);

            document.addEventListener('mouseup', function () {
                document.removeEventListener('mousemove', onMouseMove);
            }, { once: true });
        });

        point.addEventListener('touchstart', function (event) {
            function onTouchMove(event) {
                handleSliderMove(event, point);
            }

            document.addEventListener('touchmove', onTouchMove);

            document.addEventListener('touchend', function () {
                document.removeEventListener('touchmove', onTouchMove);
            }, { once: true });
        });
    }

    rangeMinInput.addEventListener('input', handleInputChange);
    rangeMaxInput.addEventListener('input', handleInputChange);

    addEventListeners(rangeUpperPoint);
    addEventListeners(rangeLowerPoint);

    updateSlider();
});
{
	// раскрываем формы поиска
	const searchform = document.querySelector('form.search');
	if (!!searchform) {
		const input = searchform.querySelector('input');
		const button = searchform.querySelector('button.btn-search');
		button.addEventListener('click', function (event) {
			if (!searchform.classList.contains('active')) {
				searchform.classList.add('focus');
				function searchOutClick(event) {
					if (!searchform.contains(event.target)) {
						searchform.classList.remove('focus');
						document.removeEventListener('click', searchOutClick);
					}
				}
				document.addEventListener('click', searchOutClick);
			}
		});

		const closeButton = searchform.querySelector('button.btn-close');
		closeButton.addEventListener('click',(e) => {
			searchform.classList.remove('focus');
			searchform.classList.remove('show');
			input.value = '';
		});
	}
}
(function () {
    // Плавая прокрутка к якорю a[href*="#"]
    // собираем все якоря
    const anchors = [].slice.call(document.querySelectorAll('a[href*="#"]'));
    anchors.forEach(function(item) {
        // каждому якорю присваиваем обработчик события
        item.addEventListener('click', function(e) {
            // убираем стандартное поведение и скролим
            e.preventDefault();
            let element = document.getElementById(item.getAttribute('href').slice(1));
            /*if (element.classList.contains('acc_title')) {
                let click = new Event("click");
                element.dispatchEvent(click);
            }*/

            element.scrollIntoView();
        });
    });
}());
function iSortingSubmit(form = 'isorting', order = 2, orderby = 0) {
    var formElement = document.querySelector('form[name=' + form + ']');
    if (formElement.length > 0) {
        formElement.querySelector('input[name=order]').value = order;
        formElement.querySelector('input[name=orderby]').value = orderby;
        formElement.submit();
    }
}
{
	// отправка формы заказа
	const iforms = document.querySelectorAll('[data-iform]');
	if (iforms.length > 0) {
		iforms.forEach(function (form) {
			form.addEventListener('submit', function (event) {
				event.preventDefault();
				event.stopPropagation();
				iformProcess(form);
			});
		});
	}
}

// Обрабатываем форму
function iformProcess(form) {
	const button = form.querySelector('[type="submit"]');
	const tokens = form.querySelectorAll('[value="1"]');
	let jtoken = '';
	const form_data = new FormData(form);

	let goalValue = '1CLICK';
	const goalInput = form.querySelector('input[name="goal"]');
	if (goalInput) {
		goalValue = goalInput.value;
	}

	//ищем токен формы
	tokens.forEach(function (input) {
		if (input.type === 'hidden' && input.name.length === 32) {
			jtoken = input.name;
		}
	});

	// создаем иконку загрузки
	const spinner = document.createElement('i');
	spinner.classList.add('spinner');
	button.appendChild(spinner);

	// если поля заполнены верно
	if (!Validate(form)) {
		const xhr = new XMLHttpRequest();
		xhr.open('POST', '?option=com_ajax&module=iform&format=json', true);
		xhr.setRequestHeader('X-CSRF-Token', jtoken);
		//xhr.setRequestHeader('Cache-Control', 'no-cache');

		xhr.addEventListener("readystatechange", () => {
			if (xhr.readyState !== XMLHttpRequest.DONE) {
				return;
			}

			if (xhr.status === 200) {
				//console.log(xhr.responseText);
				const data = JSON.parse(xhr.responseText);
				//console.log(data);
				iformUpdate(form, data);

				if (data.data.errors.length === 0) {
					try {
						switch (goalValue) {
							case '1CLICK':
								const params = JSON.parse(form_data.get('products'))[0];
								gtag("event", "purchase", {
									transaction_id: Date.now().toString(16),
									value: params.price,
									shipping: 0,
									currency: 'RUB',
									items: [{
										item_name: params.product_name,
										item_id: params.product_id,
										price: params.price,
										quantity: 1
									}]
								});
								break;

							case 'FEEDBACK':
								Goal('FEEDBACK', 'FEEDBACK_SUBMIT');
								break;

							default:
								Goal('FEEDBACK', 'FEEDBACK_SUBMIT');
						}
					} catch (e) {
						console.log('Error goal [' + goalValue + ']');
					}

					//clearCart();
					form.reset();
					form.classList.add('d-n');
					form.parentNode.querySelector('.form_thank_you').classList.add('active');
				} else {
					form.classList.remove('d-n');
				}
			}

			setTimeout(() => {
				spinner.remove();
			}, 300);
		});
		xhr.send(form_data);
	}
}

// Обновляем статусы полей в форме
function iformUpdate(form, data) {
	if (data.data.errors.length !== 0) {
		data.data.errors.forEach(function (error) {
			if (error.key !== 'header') {
				const input = form.querySelector('[name="' + error.key + '"]');
				input.classList.add('danger');
			}
		});
	}

	if (data.data.valid.length !== 0) {
		data.data.valid.forEach(function (valid) {
			const input = form.querySelector('[name="' + valid + '"]');
			input.classList.add('success');
		});
	}
}
function addToCart(data, btn) {
	const url = '/index.php?option=com_jshopping&controller=cart&task=add&ajax=1';
	const request = new XMLHttpRequest();
	const params = new FormData();
	params.append('product_id', data.product_id);
	params.append('category_id', data.category_id);
	params.append('quantity', data.count);

	var products = [{
		content_id: data.product_id,
		content_name: data.product_name,
	}];

	const spinner = document.createElement('i');
	spinner.classList.add('spinner');
	btn.appendChild(spinner);

	request.open('POST', url, true);
	request.addEventListener('readystatechange', () => {
		if (request.readyState === XMLHttpRequest.DONE) {
			if (request.status === 200) {
				const response = JSON.parse(request.responseText);

				// Электронная коммерция
				gtag("event", "add_to_cart", {
					items: [
						{
							item_name: data.product_name,
							item_id: data.product_id,
							price: data.price,
							item_brand: 'Atlant',
							item_category: data.category_name,
							index: data.index,
							quantity: 1
						}
					]
				});
			}

			setTimeout(() => {
				spinner.remove();
			}, 300);

		}
	});
	request.send(params);
}

function updateCart(count) {
	const cart = document.getElementById('cart');
	cart.querySelector('small').textContent = count;

	if (typeof textProducts !== 'undefined' && textProducts !== null) {
		cart.querySelector('span').textContent =
			count + ' ' + declension(count, textProducts);
	}
}

const buttons = document.querySelectorAll('[data-to-cart]');
if (!!buttons) {
	buttons.forEach(function(btn) {
		btn.addEventListener('click', (evt) => {
			evt.preventDefault();
			evt.stopPropagation();
			const params = JSON.parse(btn.parentNode.dataset.modal1click)[0];

			//console.log(params);

			if (params.product_id > 0 && params.category_id > 0 && params.count > 0) {
				addToCart(params, btn);
			}
			return false;
		});
	});
}
function updateQuantity(form, btn) {
	if (!form || !btn) {
		return;
	}

	const url = '/index.php?option=com_jshopping&controller=cart&task=refresh&ajax=1';
	const request = new XMLHttpRequest();
	const params = new FormData(form);

	const spinner = document.createElement('i');
	spinner.classList.add('spinner');
	btn.appendChild(spinner);

	request.open('POST', url, true);
	request.addEventListener('readystatechange', () => {
		if (request.readyState === XMLHttpRequest.DONE) {
			if (request.status === 200) {
				let response = JSON.parse(request.responseText);
				//console.log(response);
				const productsArray = Object.values(response.products);
				productsArray.forEach(function (prod){
					const item = form.querySelector('[data-productid="' + prod.product_id + '"]');
					item.querySelector('.in_cart_price').textContent = prod.price * prod.quantity + ' руб';
				});
				form.querySelector('.in_cart_total').textContent = response.price_product + ' руб';
				updateCart(response.count_product);
			}

			setTimeout(() => {
				spinner.remove();
			}, 300);
		}
	});
	request.send(params);
}

const minus = document.querySelectorAll('[data-minus]');
const plus = document.querySelectorAll('[data-plus]');
const cart = document.getElementById('cartForm');
if (minus.length > 0) {
	minus.forEach(function(btn) {
		btn.addEventListener('click', (evt) => {
			evt.preventDefault();
			evt.stopPropagation();
			const input = btn.parentNode.querySelector('input');

			if (input.value > 1) {
				input.setAttribute('value', --input.value);
				updateQuantity(cart, btn);
			}
			return false;
		});
	});
}
if (plus.length > 0) {
	plus.forEach(function(btn) {
		btn.addEventListener('click', (evt) => {
			evt.preventDefault();
			evt.stopPropagation();
			const input = btn.parentNode.querySelector('input');

			if (input.value < 1000) {
				input.setAttribute('value', ++input.value);
				updateQuantity(cart, btn);
			}
			return false;
		});
	});
}
function Validate(form) {
    let error = false;
    const emailPattern=/@/;
    const phonePattern=/[a-zа-яё]+/i;

    // выбираем все обязательные поля
    const fields = form.querySelectorAll('input[required]');
    fields.forEach(function(input) {
        if (input.value === '') {
            input.classList.add('danger');
            error = true;
        }
        else {
            input.classList.remove('danger');
        }
    });

    if(!error) {
        // выбираем все обязательные Email-поля
        const emails = form.querySelectorAll('input[type=email]');
        emails.forEach(function(email) {
            if (emailPattern.test(email.value)) {
                email.classList.remove('danger');
            }
            else {
                email.parentNode.classList.add('danger');
                error = true;
            }
        });
    }

    if(!error) {
        // выбираем все обязательные Phone-поля
        const phones = form.querySelectorAll('input[type=tel]');
        phones.forEach(function(phone) {
            if (phonePattern.test(phone.value)) {
                phone.classList.add('danger');
                error = true;
            }
            else {
                phone.classList.remove('danger');
            }
        });
    }

    return error;
}
/// worker.js

const swiffyslider = function() {
    return {
        version: "1.6.0",
        init(rootElement = document.body) {
            for (let sliderElement of rootElement.querySelectorAll(".swiffy-slider")) {
                this.initSlider(sliderElement);
            }
        },

        initSlider(sliderElement) {
            for (let navElement of sliderElement.querySelectorAll(".slider-nav")) {
                let next = navElement.classList.contains("slider-nav-next");
                navElement.addEventListener("click", () => this.slide(sliderElement, next), { passive: true });
            }
            for (let indicatorElement of sliderElement.querySelectorAll(".slider-indicators")) {
                indicatorElement.addEventListener("click", () => this.slideToByIndicator());
                this.onSlideEnd(sliderElement, () => this.handleIndicators(sliderElement), 60);
            }
            if (sliderElement.classList.contains("slider-nav-autoplay")) {
                const timeout = sliderElement.getAttribute("data-slider-nav-autoplay-interval") ? sliderElement.getAttribute("data-slider-nav-autoplay-interval") : 2500;
                this.autoPlay(sliderElement, timeout, sliderElement.classList.contains("slider-nav-autopause"));
            }
            if (["slider-nav-autohide", "slider-nav-animation"].some(className => sliderElement.classList.contains(className))) {
                const threshold = sliderElement.getAttribute("data-slider-nav-animation-threshold") ? sliderElement.getAttribute("data-slider-nav-animation-threshold") : 0.3;
                this.setVisibleSlides(sliderElement, threshold);
            }
        },

        setVisibleSlides(sliderElement, threshold = 0.3) {
            let observer = new IntersectionObserver(slides => {
                slides.forEach(slide => {
                    slide.isIntersecting ? slide.target.classList.add("slide-visible") : slide.target.classList.remove("slide-visible");
                });
                sliderElement.querySelector(".slider-container>*:first-child").classList.contains("slide-visible") ? sliderElement.classList.add("slider-item-first-visible") : sliderElement.classList.remove("slider-item-first-visible");
                sliderElement.querySelector(".slider-container>*:last-child").classList.contains("slide-visible") ? sliderElement.classList.add("slider-item-last-visible") : sliderElement.classList.remove("slider-item-last-visible");
            }, {
                root: sliderElement.querySelector(".slider-container"),
                threshold: threshold
            });
            for (let slide of sliderElement.querySelectorAll(".slider-container>*"))
                observer.observe(slide);
        },

        slide(sliderElement, next = true) {
            const container = sliderElement.querySelector(".slider-container");
            const fullpage = sliderElement.classList.contains("slider-nav-page");
            const noloop = sliderElement.classList.contains("slider-nav-noloop");
            const nodelay = sliderElement.classList.contains("slider-nav-nodelay");
            const slides = container.children;
            const gapWidth = parseInt(window.getComputedStyle(container).columnGap);
            const scrollStep = slides[0].offsetWidth + gapWidth;
            let scrollLeftPosition = next ?
                container.scrollLeft + scrollStep :
                container.scrollLeft - scrollStep;
            if (fullpage) {
                scrollLeftPosition = next ?
                    container.scrollLeft + container.offsetWidth :
                    container.scrollLeft - container.offsetWidth;
            }
            if (container.scrollLeft < 1 && !next && !noloop) {
                scrollLeftPosition = (container.scrollWidth - container.offsetWidth);
            }
            if (container.scrollLeft >= (container.scrollWidth - container.offsetWidth) && next && !noloop) {
                scrollLeftPosition = 0;
            }
            container.scroll({
                left: scrollLeftPosition,
                behavior: nodelay ? "auto" : "smooth"
            });
        },

        slideToByIndicator() {
            const indicator = window.event.target;
            const indicatorIndex = Array.from(indicator.parentElement.children).indexOf(indicator);
            const indicatorCount = indicator.parentElement.children.length;
            const sliderElement = indicator.closest(".swiffy-slider");
            const slideCount = sliderElement.querySelector(".slider-container").children.length;
            const relativeSlideIndex = (slideCount / indicatorCount) * indicatorIndex;
            this.slideTo(sliderElement, relativeSlideIndex);
        },

        slideTo(sliderElement, slideIndex) {
            const container = sliderElement.querySelector(".slider-container");
            const gapWidth = parseInt(window.getComputedStyle(container).columnGap);
            const scrollStep = container.children[0].offsetWidth + gapWidth;
            const nodelay = sliderElement.classList.contains("slider-nav-nodelay");
            container.scroll({
                left: (scrollStep * slideIndex),
                behavior: nodelay ? "auto" : "smooth"
            });
        },

        onSlideEnd(sliderElement, delegate, timeout = 125) {
            let isScrolling;
            sliderElement.querySelector(".slider-container").addEventListener("scroll", function() {
                window.clearTimeout(isScrolling);
                isScrolling = setTimeout(delegate, timeout);
            }, { capture: false, passive: true });
        },

        autoPlay(sliderElement, timeout, autopause) {
            timeout = timeout < 750 ? 750 : timeout;
            let autoplayTimer = setInterval(() => this.slide(sliderElement), timeout);
            const autoplayer = () => this.autoPlay(sliderElement, timeout, autopause);
            if (autopause) {
                ["mouseover", "touchstart"].forEach(function(event) {
                    sliderElement.addEventListener(event, function() {
                        window.clearTimeout(autoplayTimer);
                    }, { once: true, passive: true });
                });
                ["mouseout", "touchend"].forEach(function(event) {
                    sliderElement.addEventListener(event, function() {
                        autoplayer();
                    }, { once: true, passive: true });
                });
            }
            return autoplayTimer;
        },

        handleIndicators(sliderElement) {
            if (!sliderElement) return;
            const container = sliderElement.querySelector(".slider-container");
            const slidingAreaWidth = container.scrollWidth - container.offsetWidth;
            const percentSlide = (container.scrollLeft / slidingAreaWidth);
            for (let scrollIndicatorContainers of sliderElement.querySelectorAll(".slider-indicators")) {
                let scrollIndicators = scrollIndicatorContainers.children;
                let activeIndicator = Math.abs(Math.round((scrollIndicators.length - 1) * percentSlide));
                for (let element of scrollIndicators)
                    element.classList.remove("active");
                scrollIndicators[activeIndicator].classList.add("active");
            }
        }
    };
}();

window.swiffyslider = swiffyslider;
if (!document.currentScript.hasAttribute("data-noinit")) {
    if (document.currentScript.hasAttribute("defer")) {
        swiffyslider.init();
    } else {
        document.onreadystatechange = () => {
            if (document.readyState === 'interactive') {
                swiffyslider.init();
            }
        }
    }
}
const swiffysliderextensions = function() {
    return {
        version: "1.6.0",
        draggingtimer: null,
        init(rootElement = document.body) {
            for (const sliderElement of rootElement.querySelectorAll(".swiffy-slider")) {
                this.initSlider(sliderElement);
            }
        },

        initSlider(sliderElement) {
            if (sliderElement.classList.contains("slider-nav-mousedrag"))
                sliderElement.addEventListener("mousedown", (e) => this.handleMouseDrag(e, sliderElement), { passive: true });
        },

        handleMouseDrag(e, sliderElement) {
            if (e.srcElement.classList.contains('slider-nav') || e.srcElement.parentElement.classList.contains('slider-indicators'))
                return;

            const container = sliderElement.querySelector(".slider-container");
            if (sliderElement.classList.contains("dragging")) {
                clearTimeout(this.draggingtimer);
            }
            container.style.cursor = "grabbing";
            sliderElement.classList.add("dragging");

            const startingLeftPos = container.scrollLeft;
            const mouseDownStartingXPos = e.clientX;
            const slideWidth = container.children[0].offsetWidth + parseInt(window.getComputedStyle(container).columnGap);
            const maxLeftPosition = slideWidth * (container.children.length - 1);
            const startLeftScroll = container.scrollLeft;
            let nextSlideLeftPos = startLeftScroll;

            const moveDelegate = (e) => {
                const mouseMovedXpos = e.clientX - mouseDownStartingXPos;
                const nextDraggingLeftPosition = startingLeftPos - (mouseMovedXpos * 1.8);

                if (nextDraggingLeftPosition > 0 && nextDraggingLeftPosition <= maxLeftPosition) {
                    container.scrollLeft = nextDraggingLeftPosition;
                } else {
                    return;
                }
                if (mouseMovedXpos < 0) {
                    //Dragging from right to left
                    if (maxLeftPosition <= startLeftScroll) {
                        //Dragging right on last slide which is should not try to move the slides
                        nextSlideLeftPos = startLeftScroll;
                    } else {
                        nextSlideLeftPos = container.scrollLeft + (slideWidth + (mouseMovedXpos * 1.8));
                    }
                } else {
                    //Dragging from left to right
                    if (startLeftScroll > 0) {
                        nextSlideLeftPos = container.scrollLeft - (slideWidth - (mouseMovedXpos * 1.8));
                    }
                }
            }

            container.addEventListener('mousemove', moveDelegate, { passive: true });
            document.addEventListener('mouseup', () => {
                container.removeEventListener('mousemove', moveDelegate);
                container.style.cursor = null;
                if (nextSlideLeftPos < 0) { nextSlideLeftPos = 0; }
                container.scroll({
                    left: nextSlideLeftPos,
                    behavior: "smooth"
                });
                this.draggingtimer = setTimeout(() => { sliderElement.classList.remove("dragging"); }, 550);
            }, { once: true, passive: true });
        }
    };
}();

window.swiffyslider.extensions = swiffysliderextensions;
if (!document.currentScript.hasAttribute("data-noinit")) {
    window.addEventListener("load", () => {
        swiffyslider.extensions.init();
    });
}